import { memdbRequest } from "./index.js";
export function getFederation(schema, id = 1) {
    return memdbRequest.get(`/federation/${id}`, {
        params: { schema },
    });
}
//# sourceMappingURL=federation.js.map